import MainLayout from 'layouts/MainLayout';

import SettingsPage from 'pages/Settings';

import UserPage from 'pages/User';
import UsersPage from 'pages/Users';
import UsersCreatePage from 'pages/UsersCreate';

import AreaPage from 'pages/Area';
import AreasPage from 'pages/Areas';
import AreasCreatePage from 'pages/AreasCreate';

import OfficePage from 'pages/Office';
import OfficesPage from 'pages/Offices';
import OfficesCreatePage from 'pages/OfficesCreate';

import ModelPage from 'pages/Model';
import ModelsPage from 'pages/Models';
import ModelsCreatePage from 'pages/ModelsCreate';

import McpsCreate from 'pages/Mcps/Create';
import McpsDetail from 'pages/Mcps/Detail';
import McpsEdit from 'pages/Mcps/Edit';
import McpsList from 'pages/Mcps/List';

import FoldersCreate from 'pages/Folders/Create';
// import FoldersDetail from 'pages/Folders/Detail';
import FoldersList from 'pages/Documents/Folders';
import FoldersEdit from 'pages/Folders/Edit';

// import DocumentsCreate from 'pages/Documents/Create';
import DocumentsDetail from 'pages/Documents/Detail';
// import DocumentsEdit from 'pages/Documents/Edit';
import DocumentsList from 'pages/Documents/List';

import GptsCreate from 'pages/Gpts/Create';
import GptsDetail from 'pages/Gpts/Detail';
import GptsEdit from 'pages/Gpts/Edit';
import GptsList from 'pages/Gpts/List';

import AuthTokensPage from 'pages/AuthTokens';
import PublicFilePage from 'pages/PublicFile';

const routes = [{
    layout: MainLayout,
    routes: [{
        path: '/settings',
        element: SettingsPage,
        exact: true,
        analytics: { name: ["Impostazioni"] },
    }, {
        path: '/settings/users',
        element: UsersPage,
        exact: true,
        analytics: { name: ["Impostazioni", "Utenti"] },
    }, {
        path: '/settings/users/create',
        element: UsersCreatePage,
        exact: true,
        analytics: { name: ["Impostazioni", "Utenti", "Crea"] },
    }, {
        path: '/settings/users/:userId',
        element: UserPage,
        exact: true,
        analytics: { name: ["Impostazioni", "Utenti", "Dettagli Utente"] },
    }, {
        path: '/settings/areas',
        element: AreasPage,
        exact: true,
        analytics: { name: ["Impostazioni", "Aree di lavoro"] },
    }, {
        path: '/settings/areas/create',
        element: AreasCreatePage,
        exact: true,
        analytics: { name: ["Impostazioni", "Aree di lavoro", "Crea"] },
    }, {
        path: '/settings/areas/:areaId',
        element: AreaPage,
        exact: true,
        analytics: { name: ["Impostazioni", "Aree di lavoro", "Dettagli Area"] },
    }, {
        path: '/settings/offices',
        element: OfficesPage,
        exact: true,
        analytics: { name: ["Impostazioni", "Uffici"] },
    }, {
        path: '/settings/offices/create',
        element: OfficesCreatePage,
        exact: true,
        analytics: { name: ["Impostazioni", "Uffici", "Crea"] },
    }, {
        path: '/settings/offices/:officeId',
        element: OfficePage,
        exact: true,
        analytics: { name: ["Impostazioni", "Uffici", "Dettagli Ufficio"] },
    }, {
        path: '/settings/models',
        element: ModelsPage,
        exact: true,
        analytics: { name: ["Impostazioni", "Modelli"] },
    }, {
        path: '/settings/models/create',
        element: ModelsCreatePage,
        exact: true,
        analytics: { name: ["Impostazioni", "Modelli", "Crea"] },
    }, {
        path: '/settings/models/:modelId',
        element: ModelPage,
        exact: true,
        analytics: { name: ["Impostazioni", "Modelli", "Dettaglio Modello"] },
    }, {
        path: '/settings/mcps',
        element: McpsList,
        exact: true,
        analytics: { name: ["Settings", "Mcps", "List"] },
    }, {
        path: '/settings/mcps/create',
        element: McpsCreate,
        exact: true,
        analytics: { name: ["Settings", "Mcps", "Create"] },
    }, {
        path: '/settings/mcps/:mcpId',
        element: McpsDetail,
        exact: true,
        analytics: { name: ["Settings", "Mcps", "Detail"] },
    }, {
        path: '/settings/mcps/:mcpId/edit',
        element: McpsEdit,
        exact: true,
        analytics: { name: ["Settings", "Mcps", "Edit"] },
    },
    //Folder
    // {
    //     path: '/settings/folders',
    //     element: FoldersList,
    //     exact: true,
    //     analytics: { name: ["Settings", "Folders", "List"] },
    // }, {
    //     path: '/settings/folders/create',
    //     element: FoldersCreate,
    //     exact: true,
    //     analytics: { name: ["Settings", "Folders", "Create"] },
    // }, {
    //     path: '/settings/folders/:folderId',
    //     element: FoldersDetail,
    //     exact: true,
    //     analytics: { name: ["Settings", "Folders", "Detail"] },
    // }, {
    //     path: '/settings/folders/:folderId/edit',
    //     element: FoldersEdit,
    //     exact: true,
    //     analytics: { name: ["Settings", "Folders", "Edit"] },
    // },
    //Documents
    {
        path: '/settings/documents',
        element: FoldersList,
        exact: true,
        analytics: { name: ["Settings", "Documents", "Folders"] },
    }, {
        path: '/settings/documents/create',
        element: FoldersCreate,
        exact: true,
        analytics: { name: ["Settings", "Documents", "Folders", "Create"] },
    }, {
        path: '/settings/documents/:folderId',
        element: DocumentsList,
        exact: true,
        analytics: { name: ["Settings", "Documents", "Folders", "Detail"] },
    }, {
        path: '/settings/documents/:folderId/edit',
        element: FoldersEdit,
        exact: true,
        analytics: { name: ["Settings", "Documents", "Folders", "Edit"] },
    }, {
        path: '/settings/documents/:folderId/:documentId',
        element: DocumentsDetail,
        exact: true,
        analytics: { name: ["Settings", "Documents", "Folders", "Document"] },
    },
    //GPTS,
    {
        path: '/settings/gpts',
        element: GptsList,
        exact: true,
        analytics: { name: ["Settings", "Gpts", "List"] },
    },
    {
        path: '/settings/gpts/create',
        element: GptsCreate,
        exact: true,
        analytics: { name: ["Settings", "Gpts", "Create"] },
    },
    {
        path: '/settings/gpts/:gptId/edit',
        element: GptsEdit,
        exact: true,
        analytics: { name: ["Settings", "Gpts", "Edit"] },
    },
    {
        path: '/settings/gpts/:gptId',
        element: GptsDetail,
        exact: true,
        analytics: { name: ["Settings", "Gpts", "Detail"] },
    },
    //Token API
    {
        path: '/settings/authtokens',
        element: AuthTokensPage,
        exact: true,
        analytics: { name: ["Impostazioni", "Token API"] },
    },
    //VERIFICA FILE PUBBLICO
    {
        path: '/settings/publicfile',
        element: PublicFilePage,
        exact: true,
        analytics: { name: ["Settings", "PublicFile"] },
    },
    ]
}]

export default routes;